@if (!visibilityControlledByCaller) {
  <fieldset>
    <label [raskRequired]="required">{{label}}
      @if (infoText) {
        <rask-info>{{infoText}}</rask-info>
      }
    </label>
    <input type="text" id="{{aid}}" (click)="toggle()" [ngModel]="displayValue" [ngModelOptions]="{standalone: true}" placeholder="{{placeholder}}" [disabled]="disabled" readonly />
    <i class="caret fal fa-angle-down" (click)="toggle()" [hidden]="hasValue && show && !disableDeleteAll" [ngClass]="{'open': show}"></i>
    <i class="tree-remove" id="clearTreeValues" (mousedown)="delete()" [ngClass]="{'enabled': hasValue}" [hidden]="!show || disableDeleteAll"></i>
    @if (show) {
      <div class="tree-selector">
        <ul>
          <ng-container *ngTemplateOutlet="treeItems; context:{ $implicit: selectionItems}"></ng-container>
        </ul>
      </div>
    }
  </fieldset>
}
@if (show && visibilityControlledByCaller) {
  <div class="tree-selector">
    <ul>
      @if (!selectionItems || selectionItems.length === 0) {
        <li>
          <div class="item">
            {{emptyText}}
          </div>
        </li>
      }
      <ng-container *ngTemplateOutlet="treeItems; context:{ $implicit: selectionItems}"></ng-container>
    </ul>
  </div>
}
@if (rule) {
  <rask-validation-message [rule]="rule"></rask-validation-message>
}

<ng-template #treeItems let-items>
  @if (showHeader) {
    <li>
      <ng-content select="[header]"></ng-content>
    </li>
  }
  <ng-container *ngTemplateOutlet="selectionItem; context:{ $implicit: selectionItems}"></ng-container>
</ng-template>

<ng-template #selectionItem let-items>
  @for (item of items; track item) {
    <li [ngClass]="{'expandable': gotChildren}">
      <rask-checkbox class="low" [onBeforeChange]="onBeforeChangeFactory(item)" (change)="onItemChange(item)" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}" [partialChecked]="item.partialSelected"></rask-checkbox>
      <div title="{{item.tooltipText}}" class="item" (click)="toggleTree(item)" [ngClass]="getTextClass(item)">
        <i class="dd-caret far" [ngClass]="getCaretClass(item)"></i>
        {{item.text}}
      </div>
      @if (item.children && item.expanded) {
        <ul>
          <ng-container *ngTemplateOutlet="selectionItem; context:{ $implicit: item.children}"></ng-container>
        </ul>
      }
    </li>
  }
</ng-template>
